import type { ReactNode } from "react";
import Breadcrumbs, { type Crumb } from "@/components/feature/Breadcrumbs";

type PageHeaderProps = {
  eyebrow?: string;
  title: string;
  description?: string;
  crumbs: Crumb[];
  meta?: ReactNode;
};

export default function PageHeader({ eyebrow, title, description, crumbs, meta }: PageHeaderProps) {
  return (
    <section className="bg-background-100 border-b border-background-200">
      <div className="w-full px-4 md:px-8 lg:px-12 pt-24 md:pt-28 pb-10 md:pb-14">
        <Breadcrumbs items={crumbs} />
        <div className="mt-6 max-w-3xl">
          {eyebrow && (
            <span className="inline-flex items-center gap-2 text-xs font-medium tracking-[0.22em] text-primary-600 uppercase">
              <span className="w-6 h-px bg-primary-400" aria-hidden="true"></span>
              {eyebrow}
            </span>
          )}
          <h1 className="mt-3 font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 text-balance">
            {title}
          </h1>
          {description && (
            <p className="mt-5 text-sm md:text-base leading-relaxed text-foreground-600">{description}</p>
          )}
        </div>
        {meta && <div className="mt-8">{meta}</div>}
      </div>
    </section>
  );
}